import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  CONFIGURACION_FICHA_EVEDISA_MIPRES,
  CONFIGURACION_TABLA_EVEDISA_MIPRES,
  MOLECULAS_MIPRES,
} from './utilidades/evedisa-mipres.static';
import { DatosTabla } from 'src/app/compartido/tabla/utilidades/tabla.models';

@Component({
  templateUrl: './evedisa-mipres.component.html',
  styleUrls: ['./evedisa-mipres.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EvedisaMipresComponent {
  /* Configuración de la ficha */
  protected configFicha = CONFIGURACION_FICHA_EVEDISA_MIPRES;

  /* Configuración de la tabla */
  protected readonly configTabla = CONFIGURACION_TABLA_EVEDISA_MIPRES;

  /* Filas de la tabla */
  protected filas: DatosTabla = MOLECULAS_MIPRES;

  constructor() {}
}
